module.exports = __webpack_public_path__ + "components/weather-icon/static/nightpartcloud-1f00ece7bfd4c831daed76554e3dca06.webp";